<template>
    <div class="ah-page accounting-setting-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>會計科目設定</h1>
                    </div>
                    <div class="actions">
                        <el-button v-if="!isQR()" @click="onAdd" icon="el-icon-plus">新增{{ isAccountingSetting ? "明細" : "統制" }}科目</el-button>
                        <el-button v-if="!isQR()" @click="onAddFromTemplate" icon="el-icon-plus">最新範本匯入</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <div class="group-list">
                        <div v-for="item in groupList" :key="item.key" class="group-item" :class="{ active: queryParams.Typ === item.id }" @click="onGroupItemClick(item.id)">
                            <div class="number">{{ item.id }}</div>
                            <div class="name">{{ item.value }}</div>
                        </div>
                    </div>
                    <div class="item-list">
                        <div class="tool-bar">
                            <div>
                                <el-radio-group v-model="queryTyp" size="small" class="query-typ-selector" @change="onQueryTypChange">
                                    <el-radio-button :label="1">明細科目</el-radio-button>
                                    <el-radio-button :label="2">統制科目</el-radio-button>
                                </el-radio-group>
                                <div class="search-set">
                                    <el-input
                                        v-model="queryParams.Keyword"
                                        size="small"
                                        placeholder="關鍵字：項目代號、名稱"
                                        style="width: 300px"
                                        @keypress.enter.native="updateData"
                                        clearable
                                        @clear="updateData"
                                    />
                                    <el-button size="small" @click="updateData" icon="el-icon-search">搜尋</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="data-table">
                            <el-table
                                ref="table"
                                v-loading="isLoading"
                                :data="settings"
                                class="row-click ah-el-data-table accounting-setting-table"
                                style="width: 100%"
                                :height="tableHeight"
                                :key="tableKey"
                                @row-click="onRowClick"
                            >
                                <template v-if="isAccountingSetting">
                                    <el-table-column prop="accno" key="accno" label="科目代號" width="100">
                                        <template slot-scope="scope">
                                            <div class="account-number" :id="`accno-${scope.row.accno}`">{{ scope.row.accno }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="accnam" key="accnam" label="項目名稱（中文）" width="190" />
                                    <el-table-column prop="accnaM_E" key="accnaM_E" label="科目名稱（英文）" show-overflow-tooltip min-width="220" />
                                    <el-table-column prop="gccno" key="gccno" label="統制代號" width="100" />
                                    <el-table-column prop="gccnam" key="gccnam" label="統制名稱" width="190" />
                                    <el-table-column prop="dC_TYP" key="dC_TYP" label="屬性" width="70">
                                        <template slot-scope="scope">
                                            <div>
                                                <span class="accouting-dc-label dr" v-if="scope.row.dC_TYP === 1">借</span>
                                                <span class="accouting-dc-label cr" v-if="scope.row.dC_TYP === 2">貸</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="ismonth" key="ismonth" label="月計項目" width="100" align="center">
                                        <template slot-scope="scope">
                                            <i v-if="scope.row.ismonth" class="el-icon-check" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="isGaapShow" prop="gaap" key="gaap" label="資產負債表項目" width="130">
                                        <template slot-scope="scope">
                                            {{ getGaapText(scope.row.gaap) }}
                                        </template>
                                    </el-table-column>
                                </template>
                                <template v-else-if="!isAccountingSetting">
                                    <el-table-column prop="gccno" key="gccno2" label="統制科目代號" width="100">
                                        <template slot-scope="scope">
                                            <div class="account-number" :id="`gccno-${scope.row.gccno}`">{{ scope.row.gccno }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="gccnam" key="gccnam" label="統制名稱（中文）" width="180" />
                                    <el-table-column prop="gccnaM_E" key="gccnaM_E" label="統制名稱（英文）" />
                                    <el-table-column prop="dC_TYP" key="dC_TYP" label="借/貸" width="100">
                                        <template slot-scope="scope">
                                            <div>
                                                <span class="accouting-dc-label dr" v-if="scope.row.dC_TYP === 1">借</span>
                                                <span class="accouting-dc-label cr" v-if="scope.row.dC_TYP === 2">貸</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="isGaapShow" prop="gaap" key="gaap" label="資產負債表項目" width="130">
                                        <template slot-scope="scope">
                                            {{ getGaapText(scope.row.gaap) }}
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AccountingEditDialog :visible="accountingEditDialog.visible" :data="accountingEditDialog.data" :typ="queryParams.Typ" :isGaapShow="isGaapShow" @close="onCloseAccountingEditDialog" />
        <ReconciliationAccountEditDialog
            :visible="reconciliationAccountEditDialog.visible"
            :data="reconciliationAccountEditDialog.data"
            :typ="queryParams.Typ"
            :isGaapShow="isGaapShow"
            @close="onCloseReconciliationAccountEditDialog"
        />
        <AccountingItemTemplateImportDialog :visible="accountingItemTemplateImportDialog.visible" :type="queryTypeName" @close="onCloseAccountingItemTemplateImportDialog" />
    </div>
</template>
<script>
import _ from 'lodash';
import { accountingSettingGroup, gaapList } from '@/assets/commonData/options';
import AccountingEditDialog from '@/components/dashboard/Accounting/AccountingSetting/AccountingEditDialog.vue';
import ReconciliationAccountEditDialog from '@/components/dashboard/Accounting/AccountingSetting/ReconciliationAccountEditDialog.vue';
import AccountingItemTemplateImportDialog from '@/components/dashboard/Accounting/AccountingSetting/AccountingItemTemplateImportDialog.vue';

export default {
    data() {
        return {
            tableHeight: 0,
            tableKey: 1,

            isLoading: false,
            gaapList,

            queryParams: {
                Keyword: '',
                Typ: 1,
            },
            queryTyp: 1,

            displayType: 'all',
            settings: [],

            accountingEditDialog: {
                visible: false,
                data: {},
            },
            reconciliationAccountEditDialog: {
                visible: false,
                data: {},
            },
            accountingItemTemplateImportDialog: {
                visible: false,
            },
        };
    },
    components: {
        AccountingEditDialog,
        ReconciliationAccountEditDialog,
        AccountingItemTemplateImportDialog,
    },
    created() {
        this.updateData();
    },
    mounted() {
        this.resizeTableLayout();
        const { table } = this.$refs;
        setTimeout(() => {
            this.tableKey += 1;
            table.key = this.tableKey;
        }, 2);

        window.addEventListener('resize', this.resizeTableLayout);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeTableLayout);
    },
    computed: {
        groupList() {
            return accountingSettingGroup;
        },
        isAccountingSetting() {
            return this.queryTyp === 1;
        },
        queryUrl() {
            return this.isAccountingSetting ? '/AccountingSettingPage/GetAccountingSettings' : '/ReconciliationAccount/Query';
        },
        isGaapShow() {
            return this.queryParams.Typ === 1 || this.queryParams.Typ === 2 || this.queryParams.Typ === 3;
        },
        queryTypeName() {
            if (this.queryTyp === 1) return 'detail';
            if (this.queryTyp === 2) return 'reconciliation';
            return null;
        },
    },
    methods: {
        resizeTableLayout() {
            const pageHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const tableY = this.$refs.table.$el.getBoundingClientRect().top;
            const tableHeight = pageHeight - tableY - 65;
            this.tableHeight = tableHeight;
        },

        onAdd() {
            if (this.isAccountingSetting) this.accountingEditDialog.visible = true;
            else this.reconciliationAccountEditDialog.visible = true;
        },
        onAddFromTemplate() {
            this.accountingItemTemplateImportDialog.visible = true;
        },
        onGroupItemClick(selected) {
            this.queryParams.Typ = selected;
            this.updateData();
        },
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: this.queryUrl,
                    method: 'GET',
                    params: this.queryParams,
                });

                this.settings = resp.data.settings;
            } finally {
                this.isLoading = false;
            }
        },
        onRowClick(data, setting, e) {
            // eslint-disable-next-line no-underscore-dangle
            if (e.target._prevClass === 'el-radio-button__inner' || e.target._prevClass === 'el-radio-button__orig-radio') return;

            if (this.isAccountingSetting) {
                this.accountingEditDialog.visible = true;
                this.accountingEditDialog.data = data;
            } else {
                this.reconciliationAccountEditDialog.visible = true;
                this.reconciliationAccountEditDialog.data = data;
            }
        },
        getClassifyName(codeName) {
            const setting = accountingSettingGroup.find((item) => item.key === codeName);
            if (setting) return setting.value;
            return '';
        },
        getGaapText(value) {
            return _.find(gaapList, ['value', value])?.label;
        },
        async onDCTypChange(row) {
            try {
                this.isLoading = true;
                await this.$api({
                    url: '/ReconciliationAccount/Update',
                    method: 'POST',
                    data: { ...row, sot: 0, dC_TYP: row.dC_TYP },
                });
            } finally {
                this.isLoading = false;
            }
        },
        onQueryTypChange() {
            this.updateData();
        },
        async onCloseAccountingEditDialog(refreshOrAccno) {
            this.accountingEditDialog.visible = false;
            this.accountingEditDialog.data = {};
            if (refreshOrAccno) {
                await this.updateData();
                if (typeof refreshOrAccno === 'string') {
                    // check typ
                    const itemTyp = parseInt(refreshOrAccno[0], 10);
                    if ((itemTyp > 0 && itemTyp < 10) && (itemTyp !== this.queryParams.Typ)) {
                        this.queryParams.Typ = itemTyp;
                        await this.updateData();
                    }
                    // scroll to new item
                    this.scrollToId(`accno-${refreshOrAccno}`);
                }
            }
        },
        async onCloseReconciliationAccountEditDialog(refreshOrGccno) {
            this.reconciliationAccountEditDialog.visible = false;
            this.reconciliationAccountEditDialog.data = {};
            if (refreshOrGccno) {
                await this.updateData();
                if (typeof refreshOrGccno === 'string') {
                    // check typ
                    const itemTyp = parseInt(refreshOrGccno[0], 10);
                    if ((itemTyp > 0 && itemTyp < 10) && (itemTyp !== this.queryParams.Typ)) {
                        this.queryParams.Typ = itemTyp;
                        await this.updateData();
                    }
                    // scroll to new item
                    this.scrollToId(`gccno-${refreshOrGccno}`);
                }
            }
        },
        onCloseAccountingItemTemplateImportDialog(refresh) {
            this.accountingItemTemplateImportDialog.visible = false;
            // this.AccountingItemTemplateImportDialog.data = {};
            if (refresh) this.updateData();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-setting-page {
    &.ah-page {
        padding-bottom: 0;
    }
    .dc-selector {
        .el-radio-button__inner {
            padding: 10px;
            box-shadow: none;
        }
        .d-option.is-active .el-radio-button__inner {
            background-color: #f55c5c;
            border-color: #f55c5c;
        }
        .c-option.is-active .el-radio-button__inner {
            background-color: #56c500;
            border-color: #56c500;
        }
    }
    .ah-panel .panel-body {
        padding: 0;
        display: grid;
        grid-template-columns: 250px calc(100% - 250px);
        .group-list {
            padding: 20px;
            border-right: 1px solid #dcdcdc;
        }
        .item-list {
            width: 100%;
            padding: 20px;
        }
    }

    .group-item {
        padding: 8px 10px;
        cursor: pointer;
        transition: 0.2s;

        .number {
            display: inline-block;
            width: 25px;
            height: 25px;
            line-height: 26px;
            margin: 0 10px 0 0;
            text-align: center;
            color: #fff;
            font-weight: bold;
            background-color: $main-color;
            border-radius: 5px;
        }
        .name {
            display: inline-block;
            font-size: 11pt;
        }

        &.active {
            color: $main-color;
            background-color: $main-color-fade;
        }
    }

    .tool-bar {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        div:first-child {
            display: flex;
        }
        .query-typ-selector {
            margin-right: 15px;
        }
        .search-set {
            display: flex;
            gap: 5px;
        }
        .action-button {
        }
    }

    .accounting-setting-table {
        &.el-table th,
        &.el-table td {
            padding: 5px;
        }

        .account-number {
            font-family: Courier, monospace;
        }
    }

    .accouting-dc-label {
        &.dr {
            color: #f55c5c;
        }
        &.cr {
            color: #56c500;
        }
    }
}
</style>
